import React from 'react'
import { GetProjectResultType } from '../../../../services/web/types/responseWebServiceTypes'
import { UseResearcherDetailType } from './researcherDetailType'
import _ from 'lodash'
const useResearcherDetail = (props: UseResearcherDetailType) => {
    const { dataSource } = props
    const [initialData, setInitialData] = React.useState<GetProjectResultType>()

    React.useEffect(() => {
        if (dataSource) {
            setInitialData(dataSource)
        }
        // }, [JSON.stringify(dataSource)])
    }, [dataSource?.projectID ?? null, dataSource?.submittedID ?? null])

    return { initialData }
}

export default useResearcherDetail
